<template>
    <li class="green-menu">
        <a v-if="currentRegion" class="">{{ currentRegion.attributes.label }}</a>
        <a v-else class="">Region Selector</a>
        <ul class='level-0'>
            <li class="green-menu">
                <a class="">Maize for Silage </a>
                <ul class='level-1'>
                    <li  class="region-item" v-for="region in silageRegions" :key="region.id">
                        <a v-on:click="selectSilageRegion(region)" class=""><span class="region-item--label">{{ region.attributes.label }}</span><br> 
                            <span class="region-item--name">{{ region.attributes.name }}</span></a>
                    </li>
                </ul>
            </li>
            <li class="green-menu">
                <a class="">Maize for Grain </a>
                <ul class='level-1'>
                    <li class="region-item" v-for="region in grainRegions" :key="region.id">
                        <a v-on:click="selectGrainRegion(region)" class=""><span class="region-item--label">{{ region.attributes.label }}</span><br><span class="region-item--name">{{ region.attributes.name }}</span></a>
                    </li>
                </ul>
            </li>
        </ul>
    </li>
</template>
<script>
import { XIcon } from 'vue-feather-icons';
import UtilsMixin from './UtilsMixin.js';

export default {

    data() {

        const hybridType = window.localStorage.getItem('hybridType') ?? 'silage';
        const hybridRegion = window.localStorage.getItem(`${hybridType}Region`) ?? null;

        return {
            type: hybridType,
            region_id: hybridRegion,
            selectedSilageRegion: null,
            selectedGrainRegion: null,
            types: [
                {'type': 'silage', 'name': 'Silage'},
                {'type': 'grain', 'name': 'Grain'},
            ],
            modalDismissed: false,
        }
    },

    props: ['initialData', 'config'],

    mixins: [
        UtilsMixin,
    ],

    components: {
        XIcon,
    },

    watch: {
        type: {
            handler(newVal, oldVal) {
                // window.localStorage.setItem('hybridType', newVal);
                if (!newVal) {
                    return;
                }

                // this.setHybridType(newVal);
            },
            immediate: true,
        },
        silageRegion: {
            handler(newVal) {
                this.selectedSilageRegion = _.find(this.allRegions,  function(obj) {
                    return obj.id == newVal;
                });
                $('#region-select-label').text(this.silageRegionLabel)
            },
            immediate: true,
        },
        grainRegion: {
            handler(newVal) {
                this.selectedGrainRegion = _.find(this.allRegions,  function(obj) {
                    return obj.id == newVal;
                });
                $('#region-select-label').text(this.grainRegionLabel)
            },
            immediate: true,
        },
    },

    mounted() {
        this.setDefaultType();
        this.$nextTick(() => {


            // open modal only upon viewing hybrids list page
            if(this.isHybridsPage && !this.hasDismissedModal
                && (
                    (this.type == 'silage' && !this.silageRegion)
                 || (this.type =='grain' && !this.grainRegion)
                )

            ){
                $(this.$refs.regionSelectorModal).modal('show');
            }

            if(this.type == 'silage'){
                $('#region-select-label').text(this.silageRegionLabel)
            }
            if(this.type == 'grain'){
                $('#region-select-label').text(this.grainRegionLabel)
            }

            $(this.$refs.regionSilageSelect).selectpicker('val', this.silageRegion);
            $(this.$refs.regionSilageSelect).on('changed.bs.select', (e) => {
                this.selectSilageRegion(e);
            });

            $(this.$refs.regionGrainSelect).selectpicker('val', this.grainRegion);
            $(this.$refs.regionGrainSelect).on('changed.bs.select', (e) => {
                this.selectGrainRegion(e);
            });

            $(this.$refs.regionSelectorModal).on('hidden.bs.modal', function(e) {
                window.localStorage.setItem('hasDismissedModal',1);
            });

            this.$menu = new Mmenu("#mmenu", {
                "extensions": [
                    "theme-light", "position-front", "position-left"
                ],
            });
        });
    },

    computed: {
        allRegions() {
            return _.chain(this.initialData)
                .get('regions.data')
                .mapValues()
                .value();
        },
        currentRegion() {
            if (this.region_id) {
                return _.find(this.allRegions, (reg) => reg.id == this.region_id)
            }
        },
        silageRegions(){
            return _.chain(this.allRegions)
                    .filter((o) => {
                        return _.lowerCase(o.attributes.type) == 'silage'
                    })
                    .value();
        },
        grainRegions(){
            return _.chain(this.allRegions)
                    .filter((o) => {
                        return _.lowerCase(o.attributes.type) == 'grain'
                    })
                    .value();
        },
        hasDismissedModal() {
            return window.localStorage.getItem('hasDismissedModal') ?? 0;
        },
        isHybridsPage() {
            return _.get(this.config, 'page.template') == 'hybrids';
        },
        silageRegionLabel() {
            return _.get(this.selectedSilageRegion, 'label', 'Region Select');
        },
        grainRegionLabel() {
            return _.get(this.selectedGrainRegion, 'label', 'Region Select');
        }
    },

    methods: {
        selectSilageRegion(region) {
            let region_id = region.id;
            this.region_id = region_id;

            this.setSilageRegion(region_id);
            this.$menu.API.closeAllPanels();
            this.$menu.API.close();
        },
        selectGrainRegion(region) {
            let region_id = region.id;
            this.region_id = region_id;

            this.setGrainRegion(region_id);
            this.$menu.API.closeAllPanels();
            this.$menu.API.close();
        },
        setDefaultType(){
            if(window.localStorage.getItem('hybridType') === null){
                this.setHybridType(this.type);
                // window.localStorage.setItem('hybridType', this.type);
            }
        },
    },
}
</script>